<script>
export default {
  name: 'AssessmentCard',
  props: {
    assessment: {
      type: Object,
      required: true,
    },
    toStartAssessment: {
      type: Function,
      required: true,
    },



    
  },
  methods: {
    initials(name) {
        let initials = ''
        let array_name = name.split(' ')
        for ( let word of array_name){
          initials += word[0].toUpperCase()
        }
        return initials
    }
  }

}
</script>

<template>
  <div>
    <b-card
      tag="article"
      style="max-width: 300px; width: 260px; height: 440px; max-height: 440px; "
      class="m-2 shadow p-0"
      header-class="p-0"
    > 
    <!-- <b-card-header style="height: 200px; max-height: 200px;">
          <b-img thumbnail fluid :src="assessment.thirdparty_detail.logo_image || 'https://cdn.pixabay.com/photo/2021/03/02/17/37/accounting-6063321_960_720.png'" alt="Image 1"></b-img>

    </b-card-header> -->
      <template v-slot:header  style="height: 200px; max-height: 200px;">
        <div 
        style="height: 160px; max-height: 160px;"
        class="d-flex align-items-center justify-content-center bg-light p-3">
          <b-img class="w-100 h-100" :src="assessment.thirdparty_detail.logo_image || 'https://cdn.pixabay.com/photo/2021/03/02/17/37/accounting-6063321_960_720.png'" alt="Image 1"></b-img>
          <!-- <h2 class=" font-weight-light text-center text-white">{{ assessment.thirdparty_detail.full_name }}</h2> -->
        </div>

      </template>
      <b-avatar
        size="70px"
        class="m-0 border-white shadow"
        style="left: 38%; top: 120px; position: absolute; border: 4px solid"

      >
      
        <h3 class="text-white">{{ assessment.thirdparty_detail.full_name? initials(assessment.thirdparty_detail.full_name) : '-' }}</h3>
      
      </b-avatar>
      <b-card-body class="p-0 pt-2 mx-0">
        <b-card-title>{{ assessment.type_detail.name }}</b-card-title>
        <b-card-sub-title class="mb-2"></b-card-sub-title>
        <ul class="list-unstyled">
          <li
            ><span class="font-weight-bold">Empresa: </span
            >{{ assessment.thirdparty_detail.full_name }}</li
          >
          <li
            ><span class="font-weight-bold"
              >{{ assessment.thirdparty_detail.identification_type }}: </span
            >{{ assessment.thirdparty_detail.identification }}</li
          >
          <li
            ><span class="font-weight-bold">Empleados: </span
            >{{ assessment.number_of_employees }}</li
          >
          <li
            ><span class="font-weight-bold">Responsable: </span
            >{{ assessment.evaluator_detail.user_detail.first_name }} {{ assessment.evaluator_detail.user_detail.last_name }}</li
          >
        </ul>
        <!-- <pre>
                    {{ assessment }}
                  </pre> -->
      </b-card-body>
      <template v-slot:footer>
        <b-row>
          <b-col class="border-right">
            <div>
              <p class="text-center mb-0" style="font-size: x-large"
                ><i class="far fa-calendar-alt"></i
              ></p>
            </div>
            <div>
              <p class="text-center mb-0">{{ assessment.date }}</p>
            </div>
          </b-col>
          <b-col>
            <div>
              <p class="d-flex align-items-center justify-content-center mb-0">
                <b-button
                  href="#"
                  variant="primary"
                  style="font-size: small; height: 40px; width: 40px"
                  class="
                    shadow
                    rounded-circle
                    d-flex
                    align-items-center
                    justify-content-center
                  "
                  @click="toStartAssessment(assessment)"
                >
                  <!-- PENDIENTE definir ejecutar la prueba segun seleccion -->
                  <i class="fas fa-play"></i> </b-button></p
            ></div>
            <div>
              <p class="text-center mb-0">Iniciar prueba</p>
            </div>
          </b-col>
        </b-row>
      </template>
    </b-card>
  </div>
</template>